import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "currentColor",
  class: "icon__svg",
  viewBox: "0 0 96 96"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M23.5 82.9c-2.7 2.8-2.7 7.2 0 10s7.2 2.8 9.9 0L72.5 53c2.7-2.8 2.7-7.2 0-10L33.4 3.1c-2.7-2.8-7.2-2.8-9.9 0s-2.7 7.2 0 10L55.6 48z",
      style: {"fill-rule":"evenodd","clip-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render: render }